/* Tiny Snow for Shopify - small flakes, lightweight */
(() => {
  const prefersReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReduced) return;

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d", { alpha: true });

  canvas.id = "snow-canvas";
  Object.assign(canvas.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    zIndex: "9999"
  });

  document.addEventListener("DOMContentLoaded", () => document.body.appendChild(canvas));

  let w = 0, h = 0, dpr = 1;
  const flakes = [];
  const FLAKE_COUNT = 800;          // small + subtle; try 80–200
  const MAX_SIZE = 2.8;             // small flakes
  const MIN_SIZE = 0.7;
  const MAX_SPEED = 1.9;            // slow drift
  const MIN_SPEED = 0.35;
  const WIND = 0.28;                // gentle sideways movement

  function resize() {
    dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
    w = Math.floor(window.innerWidth);
    h = Math.floor(window.innerHeight);
    canvas.width = Math.floor(w * dpr);
    canvas.height = Math.floor(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function rand(min, max) { return Math.random() * (max - min) + min; }

  function resetFlake(f, top = false) {
    f.x = rand(0, w);
    f.y = top ? rand(-h, 0) : rand(-20, -5);
    f.r = rand(MIN_SIZE, MAX_SIZE);
    f.vy = rand(MIN_SPEED, MAX_SPEED);
    f.vx = rand(-WIND, WIND);
    f.a = rand(0.35, 0.85);         // transparency
    f.phase = rand(0, Math.PI * 2); // for gentle sway
  }

  function init() {
    flakes.length = 0;
    for (let i = 0; i < FLAKE_COUNT; i++) {
      const f = {};
      resetFlake(f, true);
      flakes.push(f);
    }
  }

  let rafId = null;
  function draw() {
    ctx.clearRect(0, 0, w, h);

    // Optional: slightly blur for softer flakes
    // ctx.shadowColor = "rgba(255,255,255,0.35)";
    // ctx.shadowBlur = 2;

    for (const f of flakes) {
      f.phase += 0.01;
      f.x += f.vx + Math.sin(f.phase) * 0.12;
      f.y += f.vy;

      if (f.y > h + 10 || f.x < -10 || f.x > w + 10) resetFlake(f);

      ctx.beginPath();
      ctx.fillStyle = `rgba(255,255,255,${f.a})`;
      ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
      ctx.fill();
    }

    rafId = requestAnimationFrame(draw);
  }

  function start() {
    resize();
    init();
    if (rafId) cancelAnimationFrame(rafId);
    draw();
  }

  window.addEventListener("resize", () => {
    resize();
    // Keep flake positions reasonable after resize
    for (const f of flakes) {
      f.x = Math.min(Math.max(f.x, 0), w);
      f.y = Math.min(Math.max(f.y, -20), h);
    }
  });

  // Stop when tab not visible (saves battery)
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    } else {
      if (!rafId) draw();
    }
  });

  start();
})();
